import { IconResponse, SetIconRequest } from '../models/api';
import { deleteData, getData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const setDefault = async (
  model: SetIconRequest
): Promise<ResponseData<IconResponse>> =>
  putData<IconResponse>(`api/icons/default`, model);

export const removeDefault = async (): Promise<
  ResponseData<ApiEmptyResponse>
> => deleteData(`api/icons/default`);

export const getDefault = async (): Promise<ResponseData<IconResponse>> =>
  getData<IconResponse>(`api/icons/default`);
